var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 668 120",
    style: {
      enableBackground: "new 0 0 668 120"
    },
    xmlSpace: "preserve",
    width: 178,
    height: 37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1396D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.1,114.4h-14.4v-26h2.7c2.4-0.4,4.9-1.9,5.1-8l2.3-75.8h37.7v83.8h7.2v26h-14.4v-12h-26.2V114.4z  M629.1,76c0,2.1-0.2,4.2-0.7,6.2c-0.4,2-1.2,4.6-2.3,6.2h13.9V18.6h-9L629.1,76z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.2,4.6 169.2,102.4 87.6,102.4 87.6,4.6 103,4.6 103,88.4 120.4,88.4 120.4,4.6 136.1,4.6  136.1,88.4 153.6,88.4 153.6,4.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.7,102.4h-15.4V4.6h48.5v97.8h-15.6V18.6h-17.5V102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.1,102.4h-15.5L271,84.7h-18.9l-2.7,17.7h-14.1L251,4.6h22.5L289.1,102.4z M254.1,71.4h14.8l-7.4-49.4 L254.1,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.3,63.4l-4.7,8.9v30h-15.4V4.6h15.4v42.6l20.1-42.6h15.4l-21.4,43.6l21.4,54.2h-15.8L316.3,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.1,74l10.5-69.4h21.4v97.8h-14.5V32.3l-10.6,70.1h-14.5l-11.5-69.1v69.1h-13.4V4.6h21.4L414.1,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.4,45.8h21.1v14h-21.1v28.6H499v14h-41.9V4.6H499v14h-26.5V45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504,4.6h47.5v14h-16.1v83.8h-15.4V18.6H504V4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.7,28.1c0-15.6,8.2-24.6,23.3-24.6c15.1,0,23.3,8.9,23.3,24.6v50.8c0,15.6-8.2,24.6-23.3,24.6 c-15.1,0-23.3-8.9-23.3-24.6V28.1z M572.1,79.9c0,7,3.1,9.6,8,9.6c4.9,0,8-2.7,8-9.6V27.1c0-7-3.1-9.6-8-9.6c-4.9,0-8,2.7-8,9.6 V79.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55.6,4.6 55.6,102.4 7.2,102.4 7.2,4.6 11.1,4.6 17.7,53.5 22.3,53.5 28.9,4.6 33.9,4.6 40.5,53.5  45.1,53.5 51.7,4.6  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8361b30aafd8ccb57e8ebb6c064288f.svg";
export { ForwardRef as ReactComponent };